import { HStack } from '@chakra-ui/react'

export const FooterMenuBlankItem = () => {
  return <HStack>&nbsp;</HStack>
}
